<div class="page-container">
    <ng-container header>
        <div class="header-container">
            <h1>{{ orgName }}</h1>
            <label>{{ 'aumico_components_organization_settings_subscription_org_id' | i18next }} {{ orgId }}</label>
        </div>
    </ng-container>

    <ng-container content>
        <div class="content-container">
            <ham-subscription-tiers
                [currentTierId]="currentTierId"
                (switchTier)="onTierSwitch($event)"
                (contactSales)="onContactSales()"
            ></ham-subscription-tiers>
        </div>
    </ng-container>
</div>
<ham-modal
    class="confirmation-modal"
    *ngIf="showWelcomePopup"
    showCancelButton="true"
    showCloseIcon="true"
    (cancel)="closeWelcome()"
    (save)="closeWelcomeAndStart()"
    title="{{'aumico_reports_tasks_and_closing_welcome_title' | i18next }}"
    saveText="{{'aumico_reports_tasks_and_closing_start' | i18next}}"
    cancelText="{{'aumico_reports_tasks_and_closing_cancel' | i18next}}"
    size="lg"
    variant="grayfooter"
>
    <div style="overflow: hidden">
        <img src="assets/images/projects-overview.png" alt="Overview" />
    </div>

    <p
        style="text-align: left; margin-top: 16px; white-space: pre-wrap"
        [innerHTML]="'aumico_reports_tasks_and_closing_success_message' | i18next"
    ></p>
</ham-modal>
